module.exports = __webpack_public_path__ + "assets/f7af89d2a3363210fcb34f006194dbf6.svg";